import { render, staticRenderFns } from "./order-audit-modal-new.vue?vue&type=template&id=b6bf8a1c&"
import script from "./order-audit-modal-new.vue?vue&type=script&lang=js&"
export * from "./order-audit-modal-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports